'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToolbarTitle = function (_PureComponent) {
  _inherits(ToolbarTitle, _PureComponent);

  function ToolbarTitle() {
    _classCallCheck(this, ToolbarTitle);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  ToolbarTitle.prototype.render = function render() {
    var _props = this.props,
        title = _props.title,
        className = _props.className,
        prominent = _props.prominent,
        offset = _props.offset,
        props = _objectWithoutProperties(_props, ['title', 'className', 'prominent', 'offset']);

    if (!title) {
      return null;
    }

    var fullClassName = (0, _classnames2.default)('md-title md-title--toolbar', {
      'md-title--toolbar-prominent': prominent,
      'md-title--toolbar-offset': offset
    }, className);

    if ((0, _react.isValidElement)(title)) {
      var titleEl = _react.Children.only(title);
      return (0, _react.cloneElement)(title, _extends({}, props, {
        id: titleEl.props.id || props.id,
        className: (0, _classnames2.default)(fullClassName, titleEl.props.className)
      }));
    }

    return _react2.default.createElement(
      'h2',
      _extends({}, props, {
        className: fullClassName
      }),
      title
    );
  };

  return ToolbarTitle;
}(_react.PureComponent);

ToolbarTitle.propTypes = {
  className: _propTypes2.default.string,
  prominent: _propTypes2.default.bool,
  offset: _propTypes2.default.bool,
  title: _propTypes2.default.node
};
exports.default = ToolbarTitle;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Toolbars/ToolbarTitle.js
// module id = 244
// module chunks = 79611799117203 213534597649335